<script setup>
import InputText from "primevue/inputtext";
import Button from "primevue/button";
const props = defineProps({
    template: Object,
    smsLength: Number,
    maxLength: Number,
})

</script>

<template>
    <div class="phone-frame flex flex-col justify-center  !text-black items-center">
        <div class="phone-screen">
            <div class="top-bar bg-neutral-600 text-white">
                <div class="pi pi-wifi"></div>
                <div class="time">9:41</div>
                <div class="pi pi-bolt"></div>
            </div>
            <div class="sms-header">{{ $t('forms.sms_preview_header') }}</div>
            <div class="sms-body">
                <div class="sms-bubble from-me opacity-30">
                    <p>{{ $t('forms.sms_preview_mock_1') }}</p>
                </div>
                <div class="sms-bubble from-me opacity-30">
                    <p>{{ $t('forms.sms_preview_mock_2') }}</p>
                </div>

                <div class="sms-bubble">
                    <p><slot name="text-1"></slot></p>
                    <div class="text-right text-sm" :class="smsLength > maxLength ? 'text-red-500':''">{{ smsLength }}/{{maxLength}}</div>
                </div>
                <div class="sms-edit flex gap-2 items-center justify-center opacity-60">
                    <Button icon="pi pi-plus" disabled severity="secondary" text rounded></Button>
                    <InputText :placeholder="$t('forms.sms_preview_placeholder')" fluid disabled v-model="props.template.text"></InputText>

                    <Button icon="pi pi-send" disabled rounded text></Button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.phone-frame {
    width: 380px;
    height: 760px;
    border: 8px solid #222;
    border-radius: 40px;
    padding: 8px;
    background: #000;
    display: flex;
    justify-content: center;
}

.phone-screen {
    background: #f2f2f7;
    width: 100%;
    height: 100%;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
}

.sms-header {
    background: #ffffffdd;
    padding: 14px;
    text-align: center;
    font-weight: 600;
    border-bottom: 1px solid #ccc;
}

.sms-body {
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.sms-bubble {
    width: 80%;
    padding: 12px 16px;
    background: white;
    border-radius: 16px;
    align-self: flex-start;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.top-bar {
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    font-size: 12px;
    opacity: 0.6;
}

.signal, .battery {
    width: 20px;
    height: 10px;
    background: #000;
    border-radius: 2px;
}

.time {
    font-weight: 600;
}

.sms-edit {
    margin-top: auto;
    padding-top: 20px;
}

.from-me {
    align-self: flex-end;
    background: #007aff;
    color: white;
}
</style>
